import { render, staticRenderFns } from "./advertisementUnit.vue?vue&type=template&id=512e651b&scoped=true"
import script from "./advertisementUnit.vue?vue&type=script&lang=js"
export * from "./advertisementUnit.vue?vue&type=script&lang=js"
import style0 from "./advertisementUnit.vue?vue&type=style&index=0&id=512e651b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e651b",
  null
  
)

export default component.exports